<template>
  <div class="container mt-3">
    <div style="position: relative;">
      <a href="javascript:void">
        <b-icon
          v-b-modal.setting-modal
          style="position: absolute;right: 15px;top: 15px;"
          icon="gear-fill"
          scale="1.25"
        ></b-icon>
      </a>
      <b-breadcrumb>
        <b-breadcrumb-item @click.prevent="chwd('/')">
          <b-icon icon="house-fill" scale="1.25" shift-v="1.25" shift-h="-1" aria-hidden="true"></b-icon>
        </b-breadcrumb-item>
        <b-breadcrumb-item
          v-for="e in navPathArr"
          @click.prevent="chwd(e.href)"
          :href="e.href"
          :key="e.href"
        >{{ e.path }}</b-breadcrumb-item>
      </b-breadcrumb>
    </div>
    <div class="mt-3" v-if="aplayerData.isBusy" style="position:relative">
      <b-icon
        icon="x"
        scale="1.25"
        style="position: absolute;right: 5px;z-index: 1;cursor: pointer;"
        @click="aplayerData.isBusy=false"
      ></b-icon>
      <aplayer
        autoplay
        :list="audioList"
        :music.sync="aplayerData.music"
        :repeat.sync="aplayerData.repeat"
        :shuffle.sync="aplayerData.shuffle"
      />
    </div>

    <div v-if="imgData.imgMode" class="container row" id="preview-imgs">
      <div v-for="file in imgList" :key="file.name" @click="previewImg(file.name)">
        <b-img-lazy center :src="getCompleteUrl(file.name)+'?thumb'" :alt="file.name"></b-img-lazy>
      </div>
    </div>

    <b-table
      hover
      responsive
      :items="list"
      :fields="fields"
      primary-key="nameFormat"
      head-variant="light"
      foot-variant="null"
      selected-variant="danger"
      class="border rounded mt-2"
      :per-page="pageData.perPage"
      :current-page="pageData.currentPage"
    >
      <template v-slot:cell(nameFormat)="data">
        <template v-if="data.item.type===1">
          <b-icon icon="folder" scale="1.25" aria-hidden="true" style="width:30px"></b-icon>
          <a
            :href="data.item.name + '/'"
            @click.prevent="chwd(data.item.name + '/')"
          >{{ data.item.name }}/</a>
        </template>
        <template v-else-if="data.item.type===3">
          <b-icon icon="inbox" scale="1.25" aria-hidden="true" style="width:30px"></b-icon>
          <a
            :href="data.item.name + '/'"
            @click.prevent="chwd(data.item.name + '/')"
          >{{ data.item.name }}/</a>
        </template>
        <template v-else>
          <a
            :href="getCompleteUrl(data.item.name)"
            target="_blank"
            class="list-download-a"
            title="download now"
          >
            <b-icon
              :icon="getIconType(data.item)"
              scale="1.25"
              aria-hidden="true"
              style="width:30px"
            ></b-icon>
          </a>
          <a
            :href="data.item.name+'?preview'"
            @click.prevent="preview(data.item)"
            class="mr-2"
          >{{ data.item.name }}</a>
        </template>
      </template>

      <template v-slot:custom-foot>
        <b-tr v-show="pageData.perPage<list.length">
          <b-td colspan="3" class="py-1" style="position: relative;">
            <p
              class="mt-2"
              style="position: absolute;"
            >{{ siteinfo.proxy_cookie?"Proxy via: "+siteinfo.proxy_cookie:"" }}</p>
            <div class="overflow-auto" style="display: flex;justify-content: flex-end;">
              <b-pagination
                v-model="pageData.currentPage"
                :total-rows="list.length"
                :per-page="pageData.perPage"
                class="my-0 ml-2"
              ></b-pagination>
              <b-form-select
                v-model="pageData.perPage"
                :options="pageData.pageOptions"
                style="max-width:100px;"
                class="ml-2"
              ></b-form-select>
              <b-button
                v-if="next"
                @click="updateList(nowPath,next)"
                style="max-height: 37px;"
                class="ml-2"
              >{{loadingData.isBusy?'loading...':'LoadMore'}}</b-button>
            </div>
          </b-td>
        </b-tr>
      </template>
    </b-table>

    <b-card no-body class="mt-3" v-show="readmeData.show && readmeData.text">
      <b-card-header>README.md</b-card-header>
      <b-card-body>
        <div v-html="readme"></div>
      </b-card-body>
    </b-card>

    <b-modal v-model="dplayerData.isBusy" centered hide-footer :title="dplayerData.title" size="xl">
      <video-player
        ref="videoPlayer"
        :url="dplayerData.url"
        :vtt-url="dplayerData.vttUrl"
        :path="dplayerData.path"
      />
    </b-modal>
    <b-modal v-model="imgData.isBusy" centered hide-footer :title="imgData.title" size="xl">
      <div style="display: flex;justify-content: center;">
        <b-img :src="imgData.url" fluid alt="Responsive image"></b-img>
      </div>
    </b-modal>
    <b-modal
      v-model="textData.isBusy"
      centered
      hide-footer
      :title="textData.title"
      size="xl"
      @show="previewText(textData.url,(text)=>{textData.text=text})"
    >
      <pre><code class>{{textData.text}}</code></pre>
    </b-modal>
    <b-modal ref="setting" id="setting-modal" :title="'Setting v'+siteinfo.version" centered hide-footer>
      <label>DPlayer Setting</label>
      <b-form-select v-model="dplayerData.showVtt" :options="dplayerData.showVttOpt"></b-form-select>
      <label>Proxy Setting</label>
      <b-form-select
        v-model="siteinfo.proxy_cookie"
        :options="siteinfo.proxy"
        @change="updateProxy"
      ></b-form-select>
      <label>Img Mode</label>
      <b-form-radio-group v-model="imgData.imgMode" :options="imgData.imgModeOpt"></b-form-radio-group>
      <label>Show README</label>
      <b-form-radio-group v-model="readmeData.show" :options="readmeData.showOpt"></b-form-radio-group>
    </b-modal>
  </div>
</template>
<script>
import VideoPlayer from "../components/preview/VideoPlayer";
import Aplayer from "vue-aplayer";
import marked from "marked";
import "github-markdown-css";

export default {
  name: "Filelister",
  components: {
    VideoPlayer,
    aplayer: Aplayer
  },
  data() {
    return {
      aplayerData: {
        isBusy: false,
        music: {
          src: "https://google.com/404"
        },
        repeat: "no-repeat",
        shuffle: false
      },
      dplayerData: {
        isBusy: false,
        url: "",
        vttUrl: "",
        path: "",
        title: "",
        showVtt: true,
        showVttOpt: [
          {
            text: "加载vtt字幕",
            value: true
          },
          {
            text: "不加载vtt字幕",
            value: false
          }
        ]
      },
      imgData: {
        isBusy: false,
        url: "",
        title: "",
        imgMode: false,
        imgModeOpt: [
          {
            text: "启用",
            value: true
          },
          {
            text: "关闭",
            value: false
          }
        ]
      },
      textData: {
        text: "",
        url: "",
        isBusy: false,
        title: ""
      },
      readmeData: {
        show: true,
        showOpt: [
          {
            text: "显示",
            value: true
          },
          {
            text: "隐藏",
            value: false
          }
        ],
        text: "nothing",
        map: {}
      },
      nowPath: "/",
      listCache: {},
      pageData: {
        currentPage: 1,
        perPage: 10,
        pageOptions: [
          {
            text: "10/Page",
            value: 10
          },
          {
            text: "50/Page",
            value: 50
          }
        ]
      },
      loadingData: {
        isBusy: false,
        info: "default info"
      },
      fields: [
        {
          key: "nameFormat",
          label: "Name",
          thStyle: "padding-left: 0.5rem !important;",
          class: "pl-0"
        },
        {
          key: "time",
          label: "Time",
          thStyle: "width:180px",
          class: "d-none d-md-table-cell",
          formatter: this.common.formatDate
        },
        {
          key: "size",
          label: "Size",
          thStyle: "width:120px",
          class: "text-right mr-3 d-none d-md-table-cell",
          formatter: this.common.formatSize
        }
      ],
      siteinfo: {
        site_name: "",
        site_readme: "",
        proxy: [
          {
            text: "no proxy",
            value: ""
          }
        ],
        proxy_cookie: ""
      }
    };
  },
  created: function() {
    this.nowPath = this.$route.params.pathMatch || "/";
    this.updateList(this.nowPath);
    this.updateTarget(this.common.p_h0);
  },
  methods: {
    chwd(path) {
      if (path.startsWith("/")) this.updateList(path);
      else this.updateList(this.nowPath + path);
    },
    updateList(path, spPage = "", data) {
      if (this.nowPath !== path) {
        this.$router.push({ path: "/home" + path });
        this.nowPath = path;
        if (this.listCache[path]) return;
      }
      if (this.loadingData.isBusy)
        return this.$message("Processing other tasks, try again later", "i");
      this.loadingData.isBusy = true;
      this.loadingData.info = "loading... " + path + spPage;
      console.log("try: ls " + path + spPage);
      let _this = this;
      let url = `.${this.common.urlSpCharEncode(path)}?json${
        spPage ? "&" + spPage.slice(1) : ""
      }`;
      this.common
        .axios({ url, method: data ? "post" : "get", data })
        .then(r => {
          _this.loadingData.isBusy = false;
          if (r.data.list) {
            if (!spPage) _this.$set(_this.listCache, path, r.data);
            else {
              r.data.list.forEach(e => _this.listCache[path].list.push(e));
              _this.listCache[path].next = r.data.next;
            }
            if (
              this.readmeData.show &&
              r.data.list.find(e => {
                return e.type === 0 && e.name === "README.md";
              })
            ) {
              this.$set(this.readmeData.map, path, "loading...");
              this.previewText(this.getCompleteUrl("README.md", path), text => {
                _this.readmeData.map[path] = marked(text);
              });
            }
          } else console.log(r.data);
        })
        .catch(e => {
          _this.loadingData.isBusy = false;
          console.log(e);
          if (e.response) {
            if (e.response.status !== 401)
              return _this.$message("error: " + e.response.data.info, "d");
            let p = e.response.data.info.split(":");
            _this.$prompt({
              title: "密码验证",
              message: p[1],
              ok: v => {
                let d = {};
                d[p[0]] = v;
                _this.updateList(path, spPage, d);
              }
            });
          } else {
            _this.$message("error: " + e.message, "d");
          }
        });
    },
    preview(file) {
      let path = this.nowPath + file.name;
      let url = this.common.p_h0 + this.common.urlSpCharEncode(path);

      if (file.mime.startsWith("audio")) {
        this.aplayerData.music.src = url;
        this.aplayerData.isBusy = true;
      } else if (file.mime.startsWith("video")) {
        this.dplayerData.url = url;
        let vttName = file.name + ".vtt";
        if (
          this.dplayerData.showVtt &&
          this.list.find(e => {
            return e.name === vttName;
          })
        )
          this.dplayerData.vttUrl = this.dplayerData.url + ".vtt";
        this.dplayerData.title = file.name;
        this.dplayerData.isBusy = true;
      } else if (file.mime.startsWith("image")) {
        this.imgData.url = url;
        this.imgData.title = file.name;
        this.imgData.isBusy = true;
      } else if (
        file.mime.startsWith("text") ||
        ["xml", "json"].includes(
          file.name.slice(file.name.lastIndexOf(".") + 1)
        )
      ) {
        this.textData.url = url;
        this.textData.title = file.name;
        this.textData.isBusy = true;
      } else {
        this.$message("该格式不支持预览", "p");
      }
    },
    previewText(url, targetFunc) {
      let _this = this;
      targetFunc("loading...");
      this.common.axios
        .get(url + "?json")
        .then(res => {
          targetFunc("loading from: " + res.data.url);
          if (res.data.url.startsWith("?")) {
            _this.common.axios
              .get(url + res.data.url, {
                responseType: "text"
              })
              .then(res2 => {
                targetFunc(res2.data);
              });
          } else {
            _this.common.axios
              .get(res.data.url, {
                withCredentials: false,
                responseType: "text"
              })
              .then(res2 => {
                targetFunc(res2.data);
              });
          }
        })
        .catch(e => {
          targetFunc("loading failed:" + e.message);
        });
    },
    previewImg(name) {
      this.imgData.url = this.getCompleteUrl(name);
      this.imgData.title = name;
      this.imgData.isBusy = true;
    },
    updateProxy(val) {
      this.common.axios
        .get("./admin/public/proxy?proxy=" + encodeURIComponent(val))
        .then(() => {
          this.$message("set proxy: " + val, "i");
        });
    },
    updateTarget(p_h0) {
      let _this = this;
      this.common
        .axios(p_h0 + "/admin/public/site")
        .then(res => {
          _this.siteinfo = res.data;
          _this.siteinfo.proxy.unshift({
            text: "no proxy",
            value: ""
          });
          _this.siteinfo.proxy_cookie = _this.siteinfo.proxy_cookie|| "";
          _this.readmeData.text = marked(res.data.site_readme);
        })
        .catch(err => {
          _this.siteinfo.proxy = [
            {
              text: "no proxy",
              value: ""
            }
          ];
          _this.siteinfo.proxy_cookie = "";
          _this.$message("获取site信息失败: " + err.message, "d");
        });
    },
    getIconType(file) {
      if (file.mime.startsWith("text")) {
        if (file.name.endsWith("txt")) return "file-earmark-text";
        else return "file-earmark-code";
      } else if (file.mime.startsWith("image")) {
        return "card-image";
      } else if (file.mime.startsWith("video")) {
        return "camera-video";
      } else if (file.mime.startsWith("audio")) {
        return "music-player";
      } else {
        return "file-earmark";
      }
    },
    getCompleteUrl(name, path = this.nowPath) {
      return this.common.completeUrl(path+name);
    }
  },
  computed: {
    navPathArr: function() {
      let path = this.nowPath;
      let tmpPath = "/";
      let arr = [];
      path.split("/").forEach(e => {
        if (!e) return;
        tmpPath += e;
        tmpPath += "/";
        arr.push({
          path: e,
          href: tmpPath
        });
      });
      return arr;
    },
    list: function() {
      let c = this.listCache[this.nowPath] || {
        list: [
          {
            type: 3,
            name: this.loadingData.isBusy ? "loading..." : "loading failed",
            size: NaN,
            time: undefined,
            mime: ""
          }
        ]
      };
      return c.list;
    },
    next: function() {
      let n = this.listCache[this.nowPath];
      if (n) n = n.next;
      return n;
    },
    audioList: function() {
      let l = [];
      this.list.forEach(e => {
        if (e.type === 0 && e.mime.startsWith("audio")) {
          l.push({
            title: e.name,
            src: this.getCompleteUrl(e.name)
          });
        }
      });
      return l;
    },
    imgList: function() {
      return this.list.filter(e => {
        return e.type === 0 && e.mime.startsWith("image");
      });
    },
    readme: function() {
      return this.readmeData.map[this.nowPath] || this.readmeData.text;
    }
  }
};
</script>
<style scoped>
.list-download-a {
  color: black;
}
.list-download-a:hover {
  color: red;
}
a:hover {
  color: red;
  text-decoration: none;
}

#preview-imgs div {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  margin: 5px;
  cursor: pointer;
}
#preview-imgs div img {
  width: 220px;
}
#preview-imgs div:hover {
  border: 3px solid rgba(255, 0, 0, 1);
}
</style>